// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{content:\"\"}@media (prefers-color-scheme:light){html{content:\"light\"}}@media (prefers-color-scheme:dark){html{content:\"dark\"}}dialog::backdrop{background-color:rgba(0,0,0,.6)}div:where(.swal2-container){z-index:5000}#viewerContainer{scrollbar-width:none}#viewerContainer::-webkit-scrollbar{width:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
